@if ((this.Mode === 'design') || (this.Mode === 'preview') || (this.Mode === 'instance')) {
  <div
    class="{{this.CssClass}}">
    <span class="label-span">{{this.DisplayName}}</span>
  </div>
}
